import {PlatformComponentContext} from 'src/components/platform-context/types';
import {Loader} from 'src/components/suspense';

const basicContext: PlatformComponentContext = {
  LaunchScreen: Loader,
};

export default basicContext;
